module.exports = __webpack_public_path__ + "img/875cd97ce9d2924fc14baa6193b656c6.svg";